import moment from 'moment';
export const getColumns = (timeZone: string) => {
  return {
    RULE: [
      {
        title: 'Notification Name',
        field: 'notificationName',
        headerStyle: { zIndex: 11 },
        width: '15%'
      },
      {
        title: 'Time Period',
        field: 'timeSpan',
        width: '15%',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.timeSpan + 'min';
        }
      },
      {
        title: 'Threshold Percentage',
        field: 'thresholdValue',
        width: '15%',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Threshold Limit',
        field: 'thresholdLimit',
        width: '15%',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Filter Criteria',
        field: 'filterRule',
        width: '15%',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          if (rowData.filterRule) return rowData.filterRule.split('search=')[1];
          else return rowData.filterRule;
        }
      },
      {
        title: 'Notification message',
        field: 'notificationMessage',
        width: '25%',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Search Period',
        width: '10%',
        field: 'searchPeriod',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.searchPeriod + 'min';
        }
      },
      {
        title: 'ID',
        width: '10%',
        field: 'id',
        hidden: true,
        headerStyle: { zIndex: 11 }
      }
    ],

    RESULTS: [
      {
        title: 'Notification Name',
        field: 'notificationRules.notificationName',
        headerStyle: { zIndex: 11 },
        width: '15%'
      },
      {
        title: 'Actual Value',
        field: 'actualValue',
        headerStyle: { zIndex: 11 },
        width: '15%'
      },
      {
        title: 'Expected Value',
        field: 'expectedValue',
        width: '15%',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Job Executed Time',
        field: 'jobExecutedTime',
        width: '15%',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) =>
          moment(rowData.jobExecutedTime)
            .tz(timeZone)
            .format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Notification message',
        field: 'message',
        width: '25%',
        headerStyle: { zIndex: 11 }
      }
    ]
  };
};

export default getColumns;
